import { Route, Routes } from 'react-router';

import { CustomerListPage, MyPageScheduleRegistration } from '#pages';
import { WeeklyCalendarPage } from '#pages/WeeklyCalendarPage';
import Manage from 'src/r_page/Manage';

const ManageView = () => {
  return (
    <Routes>
      <Route index element={<Manage />} />
      {/* <Route index element={<CustomerListPage />} /> */}
      {/* <Route
        index
        element={<WeeklyCalendarPage />}
      /> */}
    </Routes>
  );
};

export default ManageView;
